import clsx from "clsx";
import logoBlack from "./merge-logo-black.svg";
import logo from "./merge-logo.svg";

type Props = {
  color?: "white" | "black";
  className?: string;
};

const MergeLogo = ({ color = "white", className }: Props) => (
  <img
    src={color === "black" ? logoBlack : logo}
    alt="Merge"
    className={clsx("w-[70px] inline-block align-middle", className)}
  />
);

export default MergeLogo;
